module.exports = __webpack_public_path__ + "static/media/user2.16fce02f.png";